import { render } from "./app.vue?vue&type=template&id=0dcc667a"
import script from "./app.vue?vue&type=script&lang=js"
export * from "./app.vue?vue&type=script&lang=js"

import "./app.vue?vue&type=style&index=0&id=0dcc667a&lang=scss"

import exportComponent from "D:\\Liyg\\jzwork\\view\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__